import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Injectable({
  providedIn: 'root'
})
export class PdfServiceService {

  constructor() { }
  public async generatePdf(element: HTMLElement, fileName: string): Promise<void> {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageHeight = pdf.internal.pageSize.height;
    const pageWidth = pdf.internal.pageSize.width;
    const pageMargin = 10;

    // Clone the element to avoid modifying the original element
    const elementClone = element.cloneNode(true) as HTMLElement;
    elementClone.style.width = `${pageWidth - pageMargin * 2}px`;
    document.body.appendChild(elementClone);

    const canvas = await html2canvas(elementClone, { scale: 2 });
    document.body.removeChild(elementClone);

    const imgData = canvas.toDataURL('image/png');
    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * (pageWidth - pageMargin * 2)) / imgProps.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', pageMargin, position, pageWidth - pageMargin * 2, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', pageMargin, position, pageWidth - pageMargin * 2, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName);
  }
}
